import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { Process } from "../components/Process";
import { Journey } from "../components/Journey";
import { Insights } from "../components/Insights";
import { Faq } from "../components/Faq";
import { Careers } from "../components/Careers";
import { Contact } from "../components/Contact";
import { useSeo } from "../lib/seo";
import { useSite } from "../context/SiteContext";

const useFaqJsonLd = (faqs) => {
  useEffect(() => {
    if (!faqs?.length) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    });
    document.head.appendChild(el);
    return () => { el.remove(); };
  }, [faqs]);
};

export default function HomePage() {
  const { hash } = useLocation();
  useFaqJsonLd(useSite().faqs);
  useSeo({
    title: "Bedsolving — Hotel & Villa Management Company in Bali",
    description: "Bali hotel and villa management since 2014: operations, revenue management, branding and consulting for 37 properties across 7 regions.",
  });

  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView(), 400);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      <Hero />
      <Marquee />
      <Services />
      <Process />
      <Journey />
      <Insights />
      <Faq />
      <Careers />
      <Contact />
    </>
  );
}
